import React from 'react'
import { Button } from '../ui/button'
import Link from 'next/link'

const CtaButton = ({ title, href }: { title?: string, href?: string }) => {
  return (
    <Link href={href || '/#contact'} aria-label={title || 'Book now'}>
      <Button aria-label={title} className='bg-skillsewa-primary text-zinc-50'>
        {title || 'Book now'}
      </Button>
    </Link>
  )
}

export default CtaButton
